import React, { Component } from 'react';
import ParameterBox from 'components/instruments/ParameterBox.js';
import FrozenSample from './FrozenSample.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import PlayButton from 'components/user/PlayButton.js';
import { connect } from "react-redux";
import {setFrozenTrackPlaying} from 'actions/index.js';
import '../../Freeze.scss';

class FrozenProgressComponent extends Component {
    getProgress(i) {
        let step = this.props.currentGlobalStep % this.props.track.pattern.length();
        let percentage = step / this.props.track.pattern.length();
        let list = [];
        if (
            this.props.isPreparingToFreeze ||
            this.props.isResampling) {
            for (let i=0; i < 16; i++ ){
                if (percentage > i * 1 / 16.0) {
                    list.push(i);
                }
            }
        }
        let style = {
            backgroundColor: this.props.color
        };
        return (
            <div className={"frozen-progress"}>
              {list.map(l => <div style={style} className="progress-part"></div>)}
            </div>
        );
    }

    async expandSample() {
        /*
        let sample = await this.props.track.sample.getCopy();
        this.props.sequencerEngine.addSound(sample);
        */
    }

    play(e, number) {
        if (!this.props.isTrackFrozen) {
            // then we must first freeze
            this.props.column.saveAndPlayFrozen(number);
            return;
        }
        if (this.props.column.playing === number) {
            this.props.setPlaying(!this.props.isPlaying);
        } else {
            this.props.setPlaying(true);
        }
        this.props.column.playing = number;
    }

    onDrop(e) {
        e.stopPropagation();
        if (this.props.freezeDragging) {
            this.props.track.dragFreezeIntoColumn(
                this.props.freezeDragging, this.props.column);
        }
    }

    render() {
        let samplers = this.props.column.frozenSamples;
        return (
            <div
              onDrop={(e) => this.onDrop(e)}
              className="frozen-containers">
              {samplers.map(
                  (s, i) => <FrozenSample
                              key={s.id}
                              column={this.props.column}
                              frozenPatternPlaying={this.props.frozenPatternPlaying}
                              number={i}
                              color={this.props.color}
                              track={this.props.track}
                              sample={s}/>)}
              {this.props.number === 0 && (this.props.isPreparingToFreeze ||
                                           this.props.isResampling) ?
               <div className="frozen-container">
                 <div className="freezing-label">Freezing</div>
                 {this.getProgress()}
               </div> : ''}
          </div>
        );
    }
    /*
        {samplers.length > 0 ? 
             <ParameterBox
               name={"Volume"}
               width={100}
               parameter={this.props.column.gainParameter}
               track={this.props.track}
               color={this.props.color}/> : ''}
    */
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setPlaying: (playing) => dispatch(setFrozenTrackPlaying(props.track.subSequence.id, props.track.id, playing)),
    };
};
 
const mapStateToProps = (state, props) => {
    let id = state.sequencer.sequencerEngine && state.sequencer.sequencerEngine.getSequenceId();
    let currentStep = state.sequencer.currentStep[id] || 0;
    let currentGlobalStep = state.sequencer.currentGlobalStep[id] || 0;
    let playing = state.tracks.frozenTracksPlaying[props.track.subSequence.id] || {};
    let isResampling = state.tracks.isResampling === props.track.trackNumber;
    let isPreparingToFreeze = state.tracks.trackToFreeze && state.tracks.trackToFreeze.trackNumber === props.track.trackNumber;
    let tracksFrozen = state.tracks.tracksFrozen[props.track.subSequence.id] || {};
    let isTrackFrozen = tracksFrozen[props.track.id];

    return {
        currentGlobalStep: (isPreparingToFreeze || isResampling) && currentGlobalStep,
        isPreparingToFreeze, 
        isResampling,
        frozenSamplePlaying: props.column.playing,
        showPlayButton: true,
        isTrackFrozen: isTrackFrozen,
        selectedFreeze: state.freeze.selectedFreeze,
        freezeDragging: state.freeze.freezeDragging,
        frozenSamples: state.freeze.freezeColumnSamples[props.track.id] &&
            state.freeze.freezeColumnSamples[props.track.id][props.column.number]
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FrozenProgressComponent);
 
